import { AnnouncementModalLayout, Text } from '@wix/design-system';
import React, { useEffect } from 'react';
import AdvancedOauthCompleteInstallationIllustration from '../../assets/images/advanced-oauth-complete-installation.svg';
import { reportModalCtaClick, reportModalShown, reportModalUnmounted } from '../../bi/bi';
import { Modals } from '../../types';
import { useInstallerContext } from '../../context/InstallerContext';
import { getIsBulkInstallTriggered } from '../../selectors/bulk-installer-triggered';
import { useTranslation } from '@wix/wix-i18n-config';
import { useNewWindowHandlers } from '../../context/NewWindowHandlersContext';
export const GoToOtherTabModal = () => {
  const {
    t
  } = useTranslation();
  const {
    closeNewWindow,
    NewWindowPortal
  } = useNewWindowHandlers();
  const {
    onInstallationCompleted
  } = useInstallerContext();
  useEffect(() => {
    reportModalShown(Modals.goToOtherTab);
    return () => {
      reportModalUnmounted(Modals.goToOtherTab, getIsBulkInstallTriggered());
    };
  }, []);
  const onCloseButtonClick = () => {
    reportModalCtaClick({
      ctaName: 'close',
      modalType: Modals.goToOtherTab
    });
    if (!getIsBulkInstallTriggered()) {
      closeNewWindow();
      onInstallationCompleted({
        status: 'CANCELED'
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnnouncementModalLayout, {
    dataHook: "advanced-oauth-complete-installation-modal",
    onCloseButtonClick: onCloseButtonClick,
    title: t('advanced-oauth-complete-installation-modal.title'),
    illustration: /*#__PURE__*/React.createElement(AdvancedOauthCompleteInstallationIllustration, null)
  }, /*#__PURE__*/React.createElement(Text, null, t('advanced-oauth-complete-installation-modal.text'))), NewWindowPortal);
};
//# sourceMappingURL=GoToOtherTabModal.js.map